import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const apiKey = process.env.REACT_APP_API_KEY;
const apiUrl = process.env.REACT_APP_API_PATH;

const Unsubscribe = () => {
    // obtenemos el correo electrónico de la URL si esta puede ser: http://localhost:3000/unsubscribe/obrian.hc@gmail.com
    const email = window.location.pathname.split('/')[2];

    // enviamos el correo electrónico al backend para dar de baja
    React.useEffect(() => {
        const unsubscribe = async () => {
            const custom_headers = new Headers();
            custom_headers.append('x-api-key', `${apiKey}`);
            custom_headers.append('Content-Type', 'application/json');
            
            const raw = JSON.stringify({
                "CORREO": email,
                "ESTADO": 0
            });

            const requestOptions = {
                method: 'POST',
                headers: custom_headers,
                body: raw,
                redirect: 'follow'
            };
            
            const response = await fetch(`${apiUrl}/api/suscriptores/unsubscribe`, requestOptions);
            const result = await response.json();

            console.log(result);
        }

        if(email === '' || email === undefined || email === null) return;
        unsubscribe();

        }, [email]);
    
    return (
        <section className="section bg-primary text-white vertical" id="unsubscribe">
            <Container>
                <Row>
                    <Col lg={8} md={9} sm={12} xs={12} className="mx-auto text-center">
                        <h1 className="heading1">Darse de Baja</h1>
                        <p>Has sido dado de baja del servicio de newsletter.</p>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default Unsubscribe;